export default {
  id: null,
  compra: {},
};
